// Shared helpers for "Today / Yesterday / Mon, Jun 8" date separators used in
// the Friends chat thread and the push-to-talk voice popup.

const _startOfDay = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());

// True when two ISO timestamps fall on the same calendar day (local time).
export const sameDay = (a, b) => {
  if (!a || !b) return false;
  const da = new Date(a), db = new Date(b);
  return da.getFullYear() === db.getFullYear() && da.getMonth() === db.getMonth() && da.getDate() === db.getDate();
};

// "Today" / "Yesterday" / "Mon, Jun 8" (adds the year when it's not this year).
export const dayLabel = (iso) => {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    const today = _startOfDay(new Date());
    const that = _startOfDay(d);
    const diffDays = Math.round((today - that) / 86400000);
    if (diffDays === 0) return "Today";
    if (diffDays === 1) return "Yesterday";
    const opts = { weekday: "short", month: "short", day: "numeric" };
    if (d.getFullYear() !== new Date().getFullYear()) opts.year = "numeric";
    return d.toLocaleDateString([], opts);
  } catch { return ""; }
};
